module.exports = __webpack_public_path__ + "static/img/gdjt1.c46d997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdjt1.png
// module id = R7mS
// module chunks = 1